// File: LawyerExperienceSection.jsx
// Pure CSS | Dark theme | Lawyer/Attorney style

import { Medal, Shield, Weight } from 'lucide-react';
import React from 'react';

export default function AboutUsCard8() {
  return (<>
    <section className="law-ac-8-sec">
      <div className="law-ac-8-left">
        <h4 className="sub-ac-8">Welcome to the Lawyer Theme</h4>
        <h2><span className="gold-ac-8">20 Years</span> of Experience</h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
          labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi
          aliquip ex ea commodo consequat.
        </p>
        <button className="law-ac-8-btn">FREE CONSULTATION</button>
      </div>

      <div className="law-ac-8-right">
        <h3>Why Choose Us</h3>

        <div className="law-ac-8-features">
          <div className="f-item-ac-8">
            <div className="ficon-ac-8"><Weight size={23} color={`rgba(144, 202, 249,1)`} /></div>
            <div>
              <strong>My Title</strong>
              <p>Contrary to popular belief, Lorem Ipsum is not simply random text.</p>
            </div>
          </div>

          <div className="f-item-ac-8">
            <div className="ficon-ac-8"><Shield size={23} color={`rgba(144, 202, 249,1)`} /></div>
            <div>
              <strong>My Title</strong>
              <p>It has roots in a piece of classical Latin literature from 45 BC.</p>
            </div>
          </div>

          <div className="f-item-ac-8">
            <div className="ficon-ac-8"><Medal size={23} color={`rgba(144, 202, 249,1)`} /></div>
            <div>
              <strong>My Title</strong>
              <p>It has survived not only five centuries, but also the leap into electronic typesetting.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <style>{
        `
/* File: LawyerExperienceSection.css */
.law-ac-8-sec { margin-top:50px;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 40px;
  padding: 20px 80px;
  background: #e7e5e3;
  font-family: Inter, serif;
}

.law-ac-8-left .sub-ac-8 {
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
  color: #222;
  font-weight: 700;
}

.law-ac-8-left h2 {
  font-size: 38px;
  font-weight: 800;
  margin: 12px 0 20px;
  color: #111;
}

.gold-ac-8 {
  color: rgba(144, 202, 249,1);
}

.law-ac-8-left p {
  color: #444;
  line-height: 1.7;
  max-width: 500px;
  margin-bottom: 28px;
}

.law-ac-8-btn {
  background: transparent;
  border: 2px solid #111;
  color: #111;
  padding: 12px 26px;
  cursor: pointer;
  font-weight: 700;
  border-radius: 4px;
}

/* Right Card */
.law-ac-8-right {
  background: #111218;
  padding: 30px;
  border-radius: 10px;
  color: #fff;
  position: relative;
}

.law-ac-8-right h3 {
  font-size: 26px;
  font-weight: 800;
  margin-bottom: 26px;
  color: rgba(144, 202, 249,1);
}

.law-ac-8-features {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.f-item-ac-8 {
  display: flex;
  gap: 18px;
  align-items: flex-start;
}

.ficon-ac-8 {
  width: 40px;
  height: 40px;
  background: rgba(144, 202, 249,0.21);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: rgba(144, 202, 249,1);
}

.f-item-ac-8 strong {
  font-size: 16px;
  color: #fff;
}

.f-item-ac-8 p {
  font-size: 14px;
  color: #aaa;
  margin-top: 4px;
  max-width: 260px;
  line-height: 1.6;
}

/* Responsive */
@media(max-width:960px){
  .law-ac-8-sec { grid-template-columns: 1fr;  padding: 60px 10px;}
  
.ficon-ac-8 {
 padding:5px 10px;
    }
}`}</style>
    </>
  );
}
